// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Tabs,
  Tab
}                     from 'react-bootstrap';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import { createHashHistory } from 'history';
import { withRouter, Link } from 'react-router-dom';

import isEmpty from 'lodash.isempty';
import Pagination from 'react-paginating';

import './dashboard.scss';
import { currentDealList } from '../../../redux/actions/frontActions';

import logo from '../../../img/ddb-logo.png';
import bannerImg from '../../../img/2006380_YyczUn.png';
import noImg from '../../../img/no_img.jpg';
import dealImg from '../../../img/Deal-Photo.jpg';
import 'react-responsive-tabs/styles.css';

import ReactHtmlParser from 'react-html-parser';

import {geolocated} from 'react-geolocated';
import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';
import Reviews from './Reviews.js';
import ReviewList from './ReviewList.js';
const history = createHashHistory();
let isLoading="false", limit=6;
class SearchDeal extends Component {
  constructor(props, context){
    super(props, context);
    this.state = {
      index: 0,
      direction: null,
      menuList:'',
      currentDeals:[],
      limit: 6,
      perPage:6,
      total: '',
      searchText:'',
    };

    this.pagination = this.pagination.bind(this);
  }

  pagination = () => {
    isLoading = true;
    let default_city;
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(!this.state.default_city || this.state.default_city != siteData.default_city){
      if(siteData && siteData.default_city){
        default_city = siteData.default_city;
      }
    }
    limit = limit + this.state.perPage;
    const postData = {
      cityID : default_city,
      geolocation: "off",
      limit: limit,
      search: this.state.searchText,
    };

    this.props.currentDealList(postData);
  };

  handlePageChange = page => {
    isLoading="true";
    this.setState({
      currentPage: page
    });

    let default_city;
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(!this.state.default_city || this.state.default_city != siteData.default_city){
      if(siteData && siteData.default_city){
        default_city = siteData.default_city;
      }
    }

    let searchText = (this.props.route && this.props.route.match.params && this.props.route.match.params.searchText) ? this.props.route.match.params.searchText : '';
    if (searchText !== '')
    {
      this.setState({searchText: this.props.route.match.params.searchText })
      const postData = {
        cityID : default_city,
        geolocation :"off",
        limit: limit,
        search: this.props.route.match.params.searchText
      }
      this.props.currentDealList(postData);
    }

  };

  componentWillMount() { 
    let default_city;
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(!this.state.default_city || this.state.default_city != siteData.default_city){
      if(siteData && siteData.default_city){
        default_city = siteData.default_city;
      }
    }

    let searchText = (this.props.route && this.props.route.match.params && this.props.route.match.params.searchText) ? this.props.route.match.params.searchText : '';
    if (searchText !== '')
    {
      this.setState({searchText: this.props.route.match.params.searchText })
      const postData = {
        cityID : default_city,
        geolocation :"off",
        latitude:'26.846695',
        longitude:'80.946167',
        limit: limit,
        search: this.props.route.match.params.searchText
      }
      this.props.currentDealList(postData);
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.curDeal){
      isLoading="false";
      this.setState({total: nextProps.curDeal.total})
      this.setState({currentDeals: nextProps.curDeal.data})
    }
    if(this.props.error != nextProps.error){
      if(nextProps.error){
        isLoading='false';
      }
    }
  }
 
 render() {
    const { index, direction } = this.state;
    if(this.props.route.match && this.state.searchText != this.props.route.match.params.searchText && this.state.searchText != ''){
      this.handlePageChange(1)
    }
    let currentDeals, totalDeal = 0;
    if(!isEmpty(this.state.currentDeals)){
      totalDeal = this.state.currentDeals.length;
      currentDeals = this.state.currentDeals.map((deal, index) => 
        <Col lg={4} md={4} sm={4} xs={12} key={index}>
          <div className="deal-container shadow">
            <div className="deal-image">
              <Image src={(deal.dealImage) ? deal.imageurl+''+deal.dealImage : noImg} responsive />
            </div>
            <h2 className="dealname">{deal.mainDealText}</h2>
            <div className="merchant">{deal.legalName} | {deal.merchantName}</div>
            <div className="prices">
              {(deal.offerPrice > 0) ?
                <span className="percent">-{((deal.offerPrice/deal.retailPrice)*100).toFixed(2)}%</span>
              :
                <span className="percent">FREE</span>
              }
              <span className="price"><i className="fa fa-usd"></i>{deal.retailPrice}</span>
              <span className="current"><i className="fa fa-usd"></i>{deal.offerPrice}</span>
            </div>
            <div className="short-disc">
            {(deal.writeUp) ? ReactHtmlParser(deal.writeUp.substring(0, 180)) : ''}
            </div>
            <div className="deal-footer">
              <a className="btn btn-deal" onClick={() => history.push(`/deals-detail/${deal.dealID}`)}>View</a>
            </div>
          </div>
        </Col>
      );
    }

    const style = {
      width: '100%',
      height: '100%'
    }
    
    return(
      <div>
        {(isLoading =='true') ?   
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        } 
        
          {(!isEmpty(this.state.currentDeals)) ?
          <div className="container">
              {/*<div className="heading"><h2>Deals</h2></div>*/}
              <Row> 
                {currentDeals}
              </Row>

              {(this.state.total > totalDeal) ?
              <Row>
                <Col lg={12} md={12} sm={12} xs={12} onClick={this.pagination} className="text-center"><a className="btn btn-deal">Load More Deals</a></Col>
              </Row>
              : null}
          </div>
          : ''}
        
      </div>
    );
  }
}

SearchDeal.propTypes = {
  currentDealList: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  curDeal: state.frontReducer.curDeal,
  error: state.frontReducer.error,
})



export default connect(
  mapStateToProps,{currentDealList}
)(SearchDeal);




// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/SearchDeal.js